import React from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const TrendsAgeGraph = ({ ageGraphData }) => {
  const { t } = useTranslation();
  const barData = {
    labels: ageGraphData.labels,
    datasets: [
      {
        label: t("trends.view.salesByAge.label.male"),
        data: ageGraphData.data.male,
        backgroundColor: 'rgba(94, 114, 228, 0.7)',
        hoverBackgroundColor: 'rgba(94, 114, 228, 0.8)',
      },
      {
        label: t("trends.view.salesByAge.label.female"),
        data: ageGraphData.data.female,
        backgroundColor:  'rgba(79, 195, 247, 0.7)',
        hoverBackgroundColor: 'rgba(79, 195, 247, 0.8)',
      },
      {
        label: t("trends.view.salesByAge.label.genderOther"),
        data: ageGraphData.data.gender_other,
        backgroundColor:  'rgba(50, 50, 93, 0.7)',
        hoverBackgroundColor: 'rgba(50, 50, 93, 0.8)',
      },
      {
        label: t("trends.view.salesByAge.label.unknown"),
        data: ageGraphData.data.unknown,
        backgroundColor:  'rgba(232,244,251, 0.7)',
        hoverBackgroundColor: 'rgba(232,244,251, 0.8)',
      },
    ]
  };

  const options = {
    plugins: {
      title: {
        display: false,
        text: t("trends.view.salesByAge.label.ageWiseSales")
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        }
      },
      y: {
        stacked: true,
        grid: {
          display: false,
        }
      }
    }
  };

  return (
    <>
      <div className="chart-wrapper" style={{ width: '100%', margin: '0 auto', height: 400 }}>
          <Bar data={barData} options={options} />
      </div>
    </>
  );
};

export default TrendsAgeGraph;
